import { utils } from '@sfaas/util';

export default {
	plants_: state => {
		const { plants } = state.selectOptions;
		return plants;
	},

	shopCds_: state => {
		const { shopCds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...shopCds];
	},

	serverNames_: state => {
		const { serverNames } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...serverNames];
	},

	serviceKinds_: state => {
		const { serviceKinds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...serviceKinds];
	},

	pgmTypes_: state => {
		const { pgmTypes } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...pgmTypes];
	},

	pgmIds_: state => {
		const { pgmIds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...pgmIds];
	},

	mainFlgs_: state => {
		const { mainFlgs } = state.selectOptions;
		return [...mainFlgs];
	},

	exeEnvs_: state => {
		const { exeEnvs } = state.selectOptions;
		return [...exeEnvs];
	},

	lines_: state => {
		const { lines } = state.selectOptions;
		return [...lines];
	},

	plantCd_: state => {
		const { plantCd } = state.searchParams;
		return plantCd;
	},

	shopCd_: state => {
		const { shopCd } = state.searchParams;
		return shopCd;
	},

	serverName_: state => {
		const { serverName } = state.searchParams;
		return serverName;
	},

	serviceKind_: state => {
		const { serviceKind } = state.searchParams;
		return serviceKind;
	},

	pgmType_: state => {
		const { pgmType } = state.searchParams;
		return pgmType;
	},

	pgmId_: state => {
		const { pgmId } = state.searchParams;
		return pgmId;
	},

	show_: state => {
		const { show } = state.popupParams;
		return show;
	},

	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		Object.keys(searchParams).forEach(key => {
			const value = searchParams[key];
			if (!utils.$sf_isNull(value) && !utils.isUndefined(value) && !value.includes('ALL')) {
				urlSearchParams.set(key, value);
			}
		});
		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	},

	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	}
};
